// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-div
{
    float:right;
    width:70px;
    height:70px;
    margin-top: 10px;
    text-align: center;
    border-style: 1px;
    -webkit-user-select: none;
            user-select: none; 
    padding-right: 0;
    align-items: center;
    
}

.login-name
{
    font-size: 9px;
    text-align: center;
    float:left;
    margin-top: -3 px;
    width: 70px;
    height: 10px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space:nowrap;
    display: inline-block;
    -webkit-user-select: none;
            user-select: none; 


}
.login-datas-text
{
    text-align: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space:nowrap;
    -webkit-user-select: none;
            user-select: none; 
    margin-bottom: 10px;
}


.login-div-image
{
    width:32px;
    height: 32px;
}
.login-datas
{

    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;
    position: absolute;
    top: 40px;
    left: calc(100% - 220px);
    width:180px;
    display:flex;
    flex-direction: column;
    
    margin-top: 2px;
    border-radius: 10px;
    border-color: var(--default-icon-color);
    border-style: solid;
    border-width: 2px;
    box-shadow: 8px 8px 8px  #252525;

    
    background-color: #202020;
    z-index: 10;
}

.login-datas-button
{
    text-align: center;
    text-overflow: ellipsis;
    
    white-space:nowrap;
    -webkit-user-select: none;
            user-select: none; 
    margin-bottom: 10px;
    
}



.modal-edit-darkBG {
    background-color: rgba(0, 0, 0, 0.4);
    width: 100%;
    height: 100%;
    z-index: 1;
    top: 0px;
    left: 0px;
    
    position:fixed;
  }
  
  
  
  
  .modal-edit-centered {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
  }
  
  .modal-edit-modal {
    width: 350px;
    display: flex;
    flex-direction: column;
    min-height: 200px;
    
    background: #303030;
    color: white;
    
    border-radius: 16px;
    border-color: var(--default-icon-color);
    border-style: solid;
    border-width: 2px;
    box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.2);
    
  }
  
  .modal-edit-modalHeader {
    height: 50px;
    background: #454545;
    overflow: hidden;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    -webkit-user-select: none;
            user-select: none;
  }
  
  .modal-edit-heading {
    margin: 0;
    padding: 10px;
    color: #FFFFFF;
    font-weight: normal;
    font-size: 16px;
    text-align: center;
    
  }
  
  .modal-edit-modalContent {
    font-size: 12px;
    font-weight:300;
    color: white;
    text-align: left;
    -webkit-user-select: none;
            user-select: none;
    margin-top: 20px;
    margin-bottom: 3px;
  }
  .modal-edit-modalContent-icon
  {
      position:absolute;
      margin-top: 45px;
      margin-left: 10px;
      margin-right: 10px;
      width: 20%;  
      -webkit-user-select: none;  
              user-select: none;
  }
  .modal-edit-modalContent-text
  {
    font-size: 15px;
    position:absolute;
    margin-top: 10px;
      width:93%;  
      margin-left: 0%;
      height: 50%;
      
  }
  
  .modal-edit-modalActions {
    position: absolute;
    bottom: 2px;
    margin-bottom: 10px;
    width: 100%;
  }
  
  .modal-edit-actionsContainer {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  
  .modal-edit-closeBtn {
    cursor: pointer;
    font-weight: 500;
    padding: 4px 8px;
    border-radius: 12px;
    border: none;
    font-size: 18px;
    color: #2c3e50;
    background: var(--default-icon-color);
    transition: all 0.25s ease;
    box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.06);
    position: absolute;
    right: 0;
    top: 0;
    align-self: flex-end;
    margin-top: -7px;
    margin-right: -7px;
  }
  
  .modal-edit-closeBtn:hover {
    box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.04);
    transform: translate(-4px, 4px);
  }
  
  .modal-edit-deleteBtn {
    margin-top: 10px;
    cursor: pointer;
    font-weight: 500;
    padding: 11px 28px;
    border-radius: 12px;
    font-size: 0.8rem;
    border: none;
    color: #fff;
    background: #ff3e4e;
    transition: all 0.25s ease;
  }
  
  .modal-edit-deleteBtn:hover {
    box-shadow: 0 10px 20px -10px rgba(255, 62, 78, 0.6);
    transform: translateY(-5px);
    background: #ff3e4e;
  }
  
  .modal-edit-cancelBtn {
    margin-top: 10px;
    cursor: pointer;
    font-weight: 500;
    padding: 11px 28px;
    border-radius: 12px;
    font-size: 0.8rem;
    border: none;
    color: #2c3e50;
    background: #fcfcfc;
    transition: all 0.25s ease;
    -webkit-user-select: none;
            user-select: none;
  }
  
  .modal-edit-cancelBtn:hover {
    box-shadow: none;
    transform: none;
    background: whitesmoke;
  }
  
  
  
  .modal-edit-modal-button {
    
  
    border: solid;           /* assuming we don't want any borders */
    border-width: 2px;
    border-color: var(--default-icon-color);
    display: inline-block;  
    font-size: 25px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 4px;
    padding-bottom: 4px;
    margin-left: 6px;
    font-family:'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
    
    text-shadow: 0 0 15px black, 0 0 10px black;  
    
    -webkit-user-select: none;  
    
            user-select: none;
    background:#6B5581;
    border-radius: 10px; 
    cursor: pointer;        /* make the cursor like hovering over an <a> element */
    
  }
  
  .modal-edit-modal-div-buttons
  {
    position: relative;
    margin-top: 120px;
    
    display: flex;                  /* establish flex container */
    justify-content: right;
    margin-right: 10px;
             
  }
  
  .modal-edit-modal-button:hover {
    background:#6B5581;
    border-color: #8B75A1;
  }
  
  .modal-edit-modal-button:active {
    
    transform: translate(-2px, 2px);
  }
  
  .modal-edit-modal-image 
  {
    vertical-align: middle;
  }

  .modal-edit-formUser-label {
    
    color: white;
    text-align: left;
    font-weight: lighter;
    margin-left: 3%;
    
    
  }



  .modal-edit-formUser-input {
    display: flex;
    font-size: 14px;
    margin-left: 3%;
    width: 93%;
    flex-direction: column;
    margin-top: 0px;
    margin-bottom: 10px;
    border-radius: 6px;
    border-color: black;
    background-color: #fefefe;
}


.modal-edit-formUser-icon
{
    margin-left: 3%;
    width: 72px;
    height: 72px;
}


.modal-edit-formUser-tablebutton
{
    
    margin-top: 0px;
    margin-bottom: 15px;
    -webkit-user-select: none;
            user-select: none; 

}


`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/user/styles.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;IACX,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAiB;YAAjB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;;AAEvB;;AAEA;;IAEI,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,yBAAiB;YAAjB,iBAAiB;;;AAGrB;AACA;;IAEI,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;IACjB,mBAAmB;AACvB;;;AAGA;;IAEI,UAAU;IACV,YAAY;AAChB;AACA;;;IAGI,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,sBAAsB;;IAEtB,eAAe;IACf,mBAAmB;IACnB,uCAAuC;IACvC,mBAAmB;IACnB,iBAAiB;IACjB,gCAAgC;;;IAGhC,yBAAyB;IACzB,WAAW;AACf;;AAEA;;IAEI,kBAAkB;IAClB,uBAAuB;;IAEvB,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;IACjB,mBAAmB;;AAEvB;;;;AAIA;IACI,oCAAoC;IACpC,WAAW;IACX,YAAY;IACZ,UAAU;IACV,QAAQ;IACR,SAAS;;IAET,cAAc;EAChB;;;;;EAKA;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,iBAAiB;;IAEjB,mBAAmB;IACnB,YAAY;;IAEZ,mBAAmB;IACnB,uCAAuC;IACvC,mBAAmB;IACnB,iBAAiB;IACjB,2CAA2C;;EAE7C;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,4BAA4B;IAC5B,6BAA6B;IAC7B,yBAAiB;YAAjB,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,kBAAkB;;EAEpB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;EACA;;MAEI,iBAAiB;MACjB,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB;MAClB,UAAU;MACV,yBAAiB;cAAjB,iBAAiB;EACrB;EACA;;IAEE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;MACd,SAAS;MACT,eAAe;MACf,WAAW;;EAEf;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,qCAAqC;IACrC,0BAA0B;IAC1B,4CAA4C;IAC5C,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,4CAA4C;IAC5C,+BAA+B;EACjC;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,oDAAoD;IACpD,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,0BAA0B;IAC1B,yBAAiB;YAAjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,sBAAsB;EACxB;;;;EAIA;;;IAGE,aAAa,YAAY,uCAAuC;IAChE,iBAAiB;IACjB,uCAAuC;IACvC,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,qHAAqH;;IAErH,2CAA2C;;IAE3C,yBAAiB;;YAAjB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe,SAAS,sDAAsD;;EAEhF;;EAEA;;IAEE,kBAAkB;IAClB,iBAAiB;;IAEjB,aAAa,mBAAmB,6BAA6B;IAC7D,sBAAsB;IACtB,kBAAkB;;EAEpB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;;;EAGjB;;;;EAIA;IACE,aAAa;IACb,eAAe;IACf,eAAe;IACf,UAAU;IACV,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;;AAGA;;IAEI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;;AAGA;;;IAGI,eAAe;IACf,mBAAmB;IACnB,yBAAiB;YAAjB,iBAAiB;;AAErB","sourcesContent":[".login-div\n{\n    float:right;\n    width:70px;\n    height:70px;\n    margin-top: 10px;\n    text-align: center;\n    border-style: 1px;\n    user-select: none; \n    padding-right: 0;\n    align-items: center;\n    \n}\n\n.login-name\n{\n    font-size: 9px;\n    text-align: center;\n    float:left;\n    margin-top: -3 px;\n    width: 70px;\n    height: 10px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space:nowrap;\n    display: inline-block;\n    user-select: none; \n\n\n}\n.login-datas-text\n{\n    text-align: center;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space:nowrap;\n    user-select: none; \n    margin-bottom: 10px;\n}\n\n\n.login-div-image\n{\n    width:32px;\n    height: 32px;\n}\n.login-datas\n{\n\n    font-size: 14px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    padding-left: 10px;\n    padding-right: 10px;\n    position: absolute;\n    top: 40px;\n    left: calc(100% - 220px);\n    width:180px;\n    display:flex;\n    flex-direction: column;\n    \n    margin-top: 2px;\n    border-radius: 10px;\n    border-color: var(--default-icon-color);\n    border-style: solid;\n    border-width: 2px;\n    box-shadow: 8px 8px 8px  #252525;\n\n    \n    background-color: #202020;\n    z-index: 10;\n}\n\n.login-datas-button\n{\n    text-align: center;\n    text-overflow: ellipsis;\n    \n    white-space:nowrap;\n    user-select: none; \n    margin-bottom: 10px;\n    \n}\n\n\n\n.modal-edit-darkBG {\n    background-color: rgba(0, 0, 0, 0.4);\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    top: 0px;\n    left: 0px;\n    \n    position:fixed;\n  }\n  \n  \n  \n  \n  .modal-edit-centered {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 2;\n  }\n  \n  .modal-edit-modal {\n    width: 350px;\n    display: flex;\n    flex-direction: column;\n    min-height: 200px;\n    \n    background: #303030;\n    color: white;\n    \n    border-radius: 16px;\n    border-color: var(--default-icon-color);\n    border-style: solid;\n    border-width: 2px;\n    box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.2);\n    \n  }\n  \n  .modal-edit-modalHeader {\n    height: 50px;\n    background: #454545;\n    overflow: hidden;\n    border-top-left-radius: 16px;\n    border-top-right-radius: 16px;\n    user-select: none;\n  }\n  \n  .modal-edit-heading {\n    margin: 0;\n    padding: 10px;\n    color: #FFFFFF;\n    font-weight: normal;\n    font-size: 16px;\n    text-align: center;\n    \n  }\n  \n  .modal-edit-modalContent {\n    font-size: 12px;\n    font-weight:300;\n    color: white;\n    text-align: left;\n    user-select: none;\n    margin-top: 20px;\n    margin-bottom: 3px;\n  }\n  .modal-edit-modalContent-icon\n  {\n      position:absolute;\n      margin-top: 45px;\n      margin-left: 10px;\n      margin-right: 10px;\n      width: 20%;  \n      user-select: none;\n  }\n  .modal-edit-modalContent-text\n  {\n    font-size: 15px;\n    position:absolute;\n    margin-top: 10px;\n      width:93%;  \n      margin-left: 0%;\n      height: 50%;\n      \n  }\n  \n  .modal-edit-modalActions {\n    position: absolute;\n    bottom: 2px;\n    margin-bottom: 10px;\n    width: 100%;\n  }\n  \n  .modal-edit-actionsContainer {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n  }\n  \n  .modal-edit-closeBtn {\n    cursor: pointer;\n    font-weight: 500;\n    padding: 4px 8px;\n    border-radius: 12px;\n    border: none;\n    font-size: 18px;\n    color: #2c3e50;\n    background: var(--default-icon-color);\n    transition: all 0.25s ease;\n    box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.06);\n    position: absolute;\n    right: 0;\n    top: 0;\n    align-self: flex-end;\n    margin-top: -7px;\n    margin-right: -7px;\n  }\n  \n  .modal-edit-closeBtn:hover {\n    box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.04);\n    transform: translate(-4px, 4px);\n  }\n  \n  .modal-edit-deleteBtn {\n    margin-top: 10px;\n    cursor: pointer;\n    font-weight: 500;\n    padding: 11px 28px;\n    border-radius: 12px;\n    font-size: 0.8rem;\n    border: none;\n    color: #fff;\n    background: #ff3e4e;\n    transition: all 0.25s ease;\n  }\n  \n  .modal-edit-deleteBtn:hover {\n    box-shadow: 0 10px 20px -10px rgba(255, 62, 78, 0.6);\n    transform: translateY(-5px);\n    background: #ff3e4e;\n  }\n  \n  .modal-edit-cancelBtn {\n    margin-top: 10px;\n    cursor: pointer;\n    font-weight: 500;\n    padding: 11px 28px;\n    border-radius: 12px;\n    font-size: 0.8rem;\n    border: none;\n    color: #2c3e50;\n    background: #fcfcfc;\n    transition: all 0.25s ease;\n    user-select: none;\n  }\n  \n  .modal-edit-cancelBtn:hover {\n    box-shadow: none;\n    transform: none;\n    background: whitesmoke;\n  }\n  \n  \n  \n  .modal-edit-modal-button {\n    \n  \n    border: solid;           /* assuming we don't want any borders */\n    border-width: 2px;\n    border-color: var(--default-icon-color);\n    display: inline-block;  \n    font-size: 25px;\n    padding-left: 10px;\n    padding-right: 10px;\n    padding-top: 4px;\n    padding-bottom: 4px;\n    margin-left: 6px;\n    font-family:'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n    \n    text-shadow: 0 0 15px black, 0 0 10px black;  \n    \n    user-select: none;\n    background:#6B5581;\n    border-radius: 10px; \n    cursor: pointer;        /* make the cursor like hovering over an <a> element */\n    \n  }\n  \n  .modal-edit-modal-div-buttons\n  {\n    position: relative;\n    margin-top: 120px;\n    \n    display: flex;                  /* establish flex container */\n    justify-content: right;\n    margin-right: 10px;\n             \n  }\n  \n  .modal-edit-modal-button:hover {\n    background:#6B5581;\n    border-color: #8B75A1;\n  }\n  \n  .modal-edit-modal-button:active {\n    \n    transform: translate(-2px, 2px);\n  }\n  \n  .modal-edit-modal-image \n  {\n    vertical-align: middle;\n  }\n\n  .modal-edit-formUser-label {\n    \n    color: white;\n    text-align: left;\n    font-weight: lighter;\n    margin-left: 3%;\n    \n    \n  }\n\n\n\n  .modal-edit-formUser-input {\n    display: flex;\n    font-size: 14px;\n    margin-left: 3%;\n    width: 93%;\n    flex-direction: column;\n    margin-top: 0px;\n    margin-bottom: 10px;\n    border-radius: 6px;\n    border-color: black;\n    background-color: #fefefe;\n}\n\n\n.modal-edit-formUser-icon\n{\n    margin-left: 3%;\n    width: 72px;\n    height: 72px;\n}\n\n\n.modal-edit-formUser-tablebutton\n{\n    \n    margin-top: 0px;\n    margin-bottom: 15px;\n    user-select: none; \n\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
